<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left>
      <!-- <vdr-language-selector
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="contentLanguage$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector> -->
    </vdr-ab-left>
    <vdr-ab-right>
      <!-- <vdr-action-bar-items [locationId]="'alert-list'"></vdr-action-bar-items> -->
      <!-- <a class="btn btn-primary" [routerLink]="['./', 'create']">
        <clr-icon shape="plus"></clr-icon>
        Create
      </a> -->
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-data-table-2
  id="alert-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="alert-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  />

  <vdr-dt2-column
    id="code"
    [heading]="'common.code' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-item="item">
      {{ item.code }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="id"
    [heading]="'common.id' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-item="item">
      <a
        class="button-ghost"
        [routerLink]="['/extensions/email-templates', item.templateId]"
      >
        <span>
          {{ item.templateId }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="id"
    [heading]="'common.customer' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-item="item">
      <a
        class="button-ghost"
        [routerLink]="['/extensions/cus/general', item.customerId]"
      >
        <span>
          {{ item.customer.firstName }} {{ item.customer.lastName }}
        </span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="status" [heading]="'Status'" [hiddenByDefault]="false">
    <ng-template let-item="item">
      {{ item.status }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="attempts" [heading]="'Attempts'" [hiddenByDefault]="true">
    <ng-template let-item="item">
      {{ item.attempts }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="phone" [heading]="'Phone'" [hiddenByDefault]="true">
    <ng-template let-item="item">
      {{ item.phoneNumber }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="error" [heading]="'Error'" [hiddenByDefault]="false">
    <ng-template let-item="item">
      {{ item.errorMessage }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.created-at' | translate"
    id="created-at"
    [hiddenByDefault]="false"
    [sort]="sorts.get('createdAt')"
  >
    <ng-template let-item="item">
      {{ item.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.updated-at' | translate"
    id="created-at"
    [hiddenByDefault]="false"
    [sort]="sorts.get('updatedAt')"
  >
    <ng-template let-item="item">
      {{ item.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
